import { Project } from '../types'
import orgs from './organizations'
import roles from './roles'
import tags from './tags'

const projects: Project[] = [
  {
    name: 'GameStart',
    date: new Date('Apr 1 2012'),
    end_date: new Date('Nov 1 2018'),
    subtitle: 'K-12 video game coding school',

    role: roles.gameStartRole,
    organizations: [orgs.gameChanger],

    category: 'cto',
    details: {
      contribution: 'Founder, CEO, CTO, engineer, rainmaker',
      highlights: [
        `Dozens of Edu prototypes on DK2, Project Tango, and HoloLens`,
        `100,000+ in-person student experiences`,
        `2000 hospital bedside tutoring experiences`,
        `75 learn-to-code classes inside juvenile detention centers`,
        `70 open-source curricula (Minecraft modding, VR world creation, etc.)`,
        `Hired and trained 30 instructors`,
        `Primary focus on economically challenged communities in Detroit`
      ],
      links: [
        { url: 'http://bit.ly/GS_ClickOnDetroit', name: 'Click On Detroit Article' },
        { url: 'http://bit.ly/GS_Observer', name: 'Ann Arbor Observer Article' },
        { url: 'http://bit.ly/GS_Concentrate', name: 'Concentrate Article' },
        { url: 'http://bit.ly/GS_CrazyWisdom', name: 'Crazy Wisdom Article' },
        { url: 'http://bit.ly/GS_GamifyingDiabetesClinic', name: 'Gamifying Diabetes Clinic Article' },
        { url: 'http://www.gamestartschool.org', name: 'GameStart School home page' }
      ],

      videos: [
        {
          caption: 'Presented the story of creating GameStart School at TEDxDetroit.',
          key: 'rYCDaXgcKCA'
        }
      ],
      projectKey: 'GameStart'
    }
  },
  {
    name: 'GameChanger',
    date: new Date('May 1 2017'),
    end_date: 'Present',
    subtitle: 'AR/VR for children facing life-threatening illness',
    role: roles.gameChangerRole,
    organizations: [orgs.gameStart],
    category: 'cto',

    details: {
      contribution: `
      Currently serving as CTO to develop a pipeline of curated technology.
      `,
      context: `
      GameChanger's mission is to make cutting edge technology accessible within the hospital environment.
      Using video games, we aim to maximize impact on patient pain scores and patient well-being.
      I work alongside doctors and directors of hospital care teams to identify patient and staff needs, create budgets, and develop technical training regimens to keep staff up to speed on relevant innovations in gaming and technology.
      `,

      highlights: [
        `Serving a network of 200 children's hospitals`,
        `Site-specific AR, VR, 3D scanning and printing, and interactive live streaming experiences.`,
        `Collaborating with teams at Google DayDream, Oculus, HTC, Twitch, and Amazon Sumerian.`,
        `Custom experiences for Oculus Touch, ARCore, and HoloLens.`,
        `Creating a new role at hospitals called the "Gaming Technology Specialist".`
      ],
      links: [
        { name: 'GameChanger Charity home page', url: 'http://www.gamechangercharity.org' },
        {
          name: '$18 million in donations to GameChanger Charity',
          url:
            'https://venturebeat.com/2018/02/22/gamechanger-charity-celebrates-18-million-of-donations-with-content-platform-for-kids-in-hospitals/'
        }
      ],

      images: [
        {
          path: 'inBed.jpg',
          caption: `
          I've done training and technology installations at hospitals all over the world including: Honolulu, Denver, Ann Arbor, New York, San Antonio, San Francisco, Milwaukee, Pheonix, Fort Myers Florida, Auckland New Zealand, Brisbane QLD Australia.
          `
        },
        {
          path: 'gameChangerVr.jpg',
          caption: `
                  
          
          ` //Kapiolani Medical Center for Women and Children in Honolulu HI, Children's Hospital Colorado in Aurora CO, C.S. Mott Children's Hospital in Ann Arbor MI, Morgan Stanley in New York NY, Methodist San Antonio TX, and UCSF Benioff Children's Hospital in San Francisco CA.
        }
      ],
      projectKey: 'GameChanger'
    }
  },

  {
    name: 'Magic Leap',
    date: new Date('Mar 9 2020'),
    subtitle: 'Senior Developer Evangelist',
    role: roles.magicLeapRole,
    organizations: [orgs.magicLeap],
    tags: [tags.ar, tags.unity, tags.cSharp, tags.unreal, tags.mentorship, tags.speaking],
    details: {
      contribution: `
      Brought deep experience with Unity’s XR Platform & DOTS to a world-class Evangelism team.
      `,
      context: `
      Designed, developed, and hosted online workshops focused on Hand Input, Surface Details, Spacial UI, and Interactive Objects.

      Brought deep experience with Unity’s XR Platform, DOTS, and online workshops to a world-class Evangelism team.
      
      Created Unity Editor tools which enhanced stability, predictability and iteration time for projects simultaneously targeting Android, iOS, Oculus, HoloLens and Magic Leap hardware.
      
      Rapidly transitioned an Evangelism team from in-person events to online hands-on workshops with 100+ attendees in a matter of weeks, maintaining attendee focus and enthusiasm during this tumultuous time.
      
      Journey sadly cut short by indirect financial effects of the COVID-19 pandemic
`,
      projectKey: 'MagicLeap'
    },
    category: 'job'
  },

  {
    name: 'Bedside AR',
    date: new Date('Aug 1 2017'),
    subtitle: 'Reimagining the hospital environment',
    role: roles.gameStartRole,
    organizations: [orgs.gameStart, orgs.dayDream],
    tags: [tags.ar, tags.unity, tags.cSharp],
    details: {
      contribution: `
      I was responsible for design, coding, on-site deployment, and some minor animation work.  The project was deployed at 3 hospital locations.
      `,
      context: `
      I worked directly with the Google DayDream team using a pre-release of their ARCore library for Unity.
      The design emphasized the use of printable Image Targets as a method for hospital staff to have full control over the playspace.
      `,
      videos: [
        {
          key: '3f1SxC1QvRk',
          caption: 'This promotional video was created by our sister company, ZOTT Inc during an on-site deployment'
        }
      ],
      projectKey: 'ARCore'
    },
    category: 'project'
  },
  {
    name: 'Theraputic Riding',
    date: new Date('Jul 1 2017'),
    subtitle: 'VR for hospitalized children',
    role: roles.gameStartRole,
    organizations: [orgs.gameStart, orgs.tri],
    tags: [tags.vr, tags.unity],

    details: {
      contribution: `
      I was responsible for design, coding, and deployment.  
      Collaborated on-site at the horse ranch with a team of equestrian and Child Life specialists.
      `,
      context: `Theraputic Riding Inc has been a parter to C.S. Mott Children's Hospital for many years.
      Together they create opportunities for children facing life-threatening illness to visit a horse ranch, discover riding techniques, and learn about animal care.
      The goal of this project was to give children a taste of horse riding while still in the hospital to prepare them for an eventual trip to the real ranch.  
      We were able to personally provide experiences to more than 100 children over the project's lifespan, both in-patient at the hospital as well as when visiting the ranch.
      `,

      videos: [
        { key: 'ZBnUOI-Pqvg', caption: 'Hand detection using Leap Motion + Oculus DK2' },
        { key: 'oLwm4hlWeAQ', caption: '' }
      ],
      projectKey: 'OnTheTrail'
    },

    category: 'project'
  },
  // {
  //   name: 'RollerBuggy',
  //   date: new Date('Feb 1 2018'),
  //   subtitle: 'A gameful approach to crosswalk safety',
  //   context: 'lskdfj ;laksjdf ;lkasdjf l;kasjfdl; aksdjflskdjflsk fjkdsfkl sfkjs flksa fjlkd fj ks fdljk',
  //   contribution: 'jslkdfj lskdj flksd fjlksjd flkdsj flskjdfl sk jf ldsk fjlks',
  //   role: roles.gameStartRole,
  //   organizations: [orgs.gameStart, orgs.mott],
  //   tags: [tags.unity, tags.cSharp, tags.maya, tags.ios, tags.android],
  //   projectKey: 'RollerBuggy',
  //   category: 'project'
  // },
  {
    name: 'GameStart VRx',
    date: new Date('Jan 1 2016'),
    subtitle: 'Patient-participatory virtual spaces',
    role: roles.gameStartRole,
    organizations: [orgs.gameStart, orgs.mott],
    tags: [tags.ar, tags.vr, tags.unity, tags.cSharp],
    details: {
      contribution: `
     I created an in-patient VR program at C.S. Mott Children's Hospital which generated over 2500 in-patient VR experiences.
    `,
      context: `
    In collaboration with several key internal advocates, I brought the program to life from initial visioning to deployment including tools development, hiring and training staff, and communicating impact to hospital executives.
    Youth typically began with commercially available experiences and would then be encouraged to create and share their own virtual spaces using Unity.  Primarily utilized Oculus Rift and HTC Vive.
    `,
      links: [
        {
          url:
            'https://www.nbcnews.com/nightly-news/video/hospital-walls-disappear-into-virtual-reality-for-young-patients-643630659678',
          name: 'NBC News video'
        },
        {
          url: 'https://www.mottchildren.org/mott-support-services/therapeutic-gaming-and-digital-technology',
          name: 'Official Hospital Profile from C.S. Mott Childrens Hospital'
        },
        {
          url: 'https://techcrunch.com/2015/12/08/heres-what-virtual-reality-means-for-kids-stuck-in-the-hospital/',
          name: 'Tech Cruch article'
        },
        {
          url:
            'http://uofmhealthblogs.org/childrens/voices-from-mott/a-dream-job-using-digital-technology-to-support-healing/27249/',
          name: 'Interview with our primary contact, JJ Bouchard'
        }
      ],
      videos: [
        { key: 'XiYa6jeSKGk', caption: '' },
        { key: 'RDqhpV4B-zU', caption: '' },
        { key: 'RIgxRhz6lmM', caption: '' }
      ],
      projectKey: 'MottVR'
    },
    category: 'project'
  },
  {
    name: 'Twitch Extension',
    date: new Date('Jan 1 2019'),
    subtitle: 'Fundraising for online charity events',
    role: roles.gameChangerRole,
    organizations: [orgs.twitch, orgs.gameChanger],
    tags: [tags.serverless, tags.node, tags.vuejs, tags.aws],

    details: {
      contribution: `
      Responsible for design, development, deployment, and upkeep.
      Built with Vue.js, AWS DynamoDB, and AWS Lambda.
      `,
      context: `
        Charity streams on Twitch are a major pillar of GameChanger Charity's funding.
        We had the unique opportunity to pioneer Twitch's new Extension platform with early permission to implement Amazon Pay for donation processing.
        I worked with specialists from the Twitch team to design and implement a low-friction donation experience focused on keeping viewers engaged using AWS DynamoDB, AWS Lambda functions, and Vue.js.
        `,
      images: [
        {
          path: 'gbcEventCard.jpg',
          caption: `Since launch, we have processed tens of thousands of dollars in donations towards GameChanger Charity's programs.`
        }
      ],
      videos: [],
      projectKey: 'TwitchExtension'
    },
    category: 'project'
  },

  {
    name: 'PyMEL Tools',
    date: new Date('Jan 1 2010'),
    subtitle: 'Artist-centered workflow automation',
    role: roles.codaRole,
    organizations: [orgs.twoGear],
    tags: [tags.unreal, tags.maya, tags.pymel],
    details: {
      contribution: `
    Wrote and released a robust set of character creation tools for Maya written in Python.
    `,
      context: `
    When I started working on Coda in 2007, workflows involving normal map generation were arcane, tedious, and error-prone.  
    Having felt burned by MEL in several previous projects, the switch to PyMEL was a breath of fresh air.    
    I was able to achieve a simplicity in my approach which saved time and reduced the creative entropy.
    `,

      links: [
        {
          url: 'http://pages.cs.wisc.edu/~denrei/portfolioSite/html/tools.html',
          name: 'Additional details in my old portfolio'
        }
      ],
      projectKey: 'PyMEL',
      videos: [{ key: 'f_98yEQEjqU', caption: 'Original Demo Video' }],
      images: [
        {
          path: 'denreiMaya.jpg',
          caption: `The toolset also included some animation features. Animation can be mirrored across a rig on a per-frame basis or in batch. An extension of this functionality is used in the animation-cycling tool. Walk and run cycles can be quickly created by animating the first half of the motion which is then mirrored across the character and seamlessly cycled for playback and export.`
        }
      ]
    },
    category: 'project'
  },
  {
    name: 'Coda',
    date: new Date('Jan 1 2007'),
    subtitle: 'Sword combat mod for UT3',

    role: roles.codaRole,
    organizations: [orgs.twoGear],
    tags: [tags.unreal, tags.maya, tags.pymel],

    details: {
      contribution: `
      I was responsible for all modeling, animation, programming, and design.
      Shipped and maintained to an enthusiastic community hosting well populated servers for over 3 years.
      Built with Unreal Engine 3 UDK.
      `,
      context: `
      Coda was a free stand-alone indie game with a focus on thoughtful, unforgiving, competitive, fast paced and stylish gameplay.
  
      Some of Coda's notable accomplishments include:
      Highly polished, competitive networked sword combat system
      MakeSomethingUnrealContest Winner in Phases 1, 2, and 3
      First and only UT3 mod playable the PlayStation3
      Auto Updater/Installer
      Localized to 5 languages
      9 maps at launch
      4 original characters with customizable character color palettes
      Rideable horse with mounted sword attacks
  
      `,

      links: [{ url: 'http://www.codagame.com', name: 'Coda home page' }],
      projectKey: 'Coda',
      videos: [{ key: 'zDXGhZK7jME', caption: 'Original Release Trailer' }]
    },
    category: 'project'
  },

  {
    name: 'Procedure Prep WebVR',
    date: new Date('May 1 2018'),
    subtitle: 'WebVR for medical instruction',
    role: roles.gameChangerRole,
    organizations: [orgs.gameChanger, orgs.sumerian],
    tags: [tags.vr, tags.webVr, tags.serverless],

    details: {
      contribution: `
      I was responsible for design, coding, on-site deployment, and some minor modeling.
      Built with Amazon Sumerian.
      `,
      context: `
        In early 2018, GameChanger Charity had the opportunity to leverage a pre-release version of Amazon's new WebVR platform for pediatric care.
        I worked with hospital specialists at C.S. Mott Children's Hospital (Ann Arbor, Michigan) and Colorado Children's Hospital to design and implement a small experience focused on young patients preparing for surgery.
        Using Amazon Sumerian's digital characters, we walk the patient through a script while allowing them to grab and manipulate a 3D representation of the unique conditions in their heart.
        `,
      images: [
        {
          path: 'sumerianHeart.png',
          caption: `Starting from a basic script and some images, we developed an animated heart which patients could grab and hold.`
        },
        {
          path: 'sumerianMirror.jpg',
          caption: ``
        }
      ],
      videos: [{ key: '0ZH7fuZXG-w', caption: `Promotional video recorded at Children's Hospital Colorado` }],

      projectKey: 'Sumerian'
    },

    category: 'project'
  },

  {
    name: 'Diabetes Education',
    date: new Date('Oct 1 2014'),
    subtitle: 'Type 1 Diabetes education',

    role: roles.gameStartRole,
    organizations: [orgs.gameStart, orgs.healthDesign],
    tags: [tags.unity, tags.cSharp],

    details: {
      contribution: `
      I was responsible for design and development of a mobile game which aimed to replace the hospital's traditional educational curriculum for early onset Type 1 Diabetes patients.
      `,
      context: `
    This project was a collaboration with Dr. Joyce Lee and her team of Type 1 Diabetes specialists at the University of Michigan.    
    We partnered with young patients to create prototypes in small workshops for teens with diabetes hosted at Mott Hospital, the JDRF Type 1 Conference, and the We #MakeHealthFest. 
    Our team secured a Patient Education Award from the University of Michigan Health System, and worked with the Mott Pediatric Diabetes Team to develop a type 1 diabetes educational curriculum delivered to children.
    `,

      projectKey: 'HealthByUs',
      videos: [
        { key: '-P-uSMz-d3g', caption: `We held regular design sessions with children living with Type 1 Diabetes.` },
        { key: '-3aFLDDixsA', caption: `Gameplay experiment focused on balancing insulin levels.` }
      ],
      images: [
        {
          path: 'diabetesBrainstorm.jpg',
          caption: ``
        }
      ],
      links: [
        { url: 'http://bit.ly/GS_GamifyingDiabetesClinic', name: 'Gamifying Diabetes Clinic' },
        { url: 'http://bit.ly/GS_MedCity', name: 'MedCity Article' }
      ]
    },
    category: 'project'
  },

  {
    name: 'Saagara AR',
    date: new Date('Jul 1 2012'),
    subtitle: 'Experiencing health in new ways',

    role: roles.saagaraRole,
    organizations: [orgs.saagara],
    tags: [tags.ar, tags.unity, tags.cSharp, tags.ios, tags.android],
    details: {
      contribution: `
      I consulted with the team at Saagara to provide leadership in user experience and Unity design patterns at a time when AR experiences were relatively uncommon. 
      Helped define a user experience strategy and led the team to an on-time and bug-free launch on iOS and Android.
      Built with Unity 3.5/4 + Vuforia.`,
      context: `
    As a health-tech company, Saagara saw a huge opportunity to create something practical and beautiful. 
    They wanted to distribute information in a way that captures people’s imagination. 
    Saagara created augmented reality enabled posters to engage, inform and entertain with the goal of spreading awareness about methods to improve health.
    `,

      links: [{ url: 'http://www.saagara.com/ar', name: 'Saagara AR home page' }],
      projectKey: 'Saagara',
      videos: [{ key: '0c-4lz8w1U8', caption: '' }]
    },

    category: 'project'
  },
  {
    name: 'Flashbike Arena',
    date: new Date('Jan 1 2011'),
    subtitle: 'Tight controls, satisfying progression',

    role: roles.twoGearRole,
    organizations: [orgs.twoGear],
    tags: [tags.unreal, tags.maya, tags.pymel, tags.ios, tags.android],

    details: {
      contribution: `
    I was responsible for all art, design, and programming on Flashbike Arena, a TRON-like lightbike game for iOS built.
    Built with Unreal Engine 3 UDK. 
    `,
      context: `
    Built for iOS using Epic’s Unreal Development Kit (UDK).
    Flashbike Arena is an Unreal Engine powered iPhone, iPad, and iPod Touch game. 
    In Flashbike Arena you control a futuristic motorbike, a "flashbike", which leaves a colored wall in its wake. 
    Points are earned by causing enemies to crash into their own or your wall. 
    Additional points and multipliers can be earned through collecting the "energy cores" left behind as the wreckage of a crashed bike. 
    It's these cores that power the bikes and generate their walls!
    `,

      links: [{ url: 'http://www.flashbikearena.com', name: 'Flashbike home page' }],

      projectKey: 'Flashbike',
      videos: [{ key: 'mph1QaWQOdw', caption: 'Original Release Trailer' }]
    },
    category: 'project'
  }
]

export default projects

const codaStuff = `
With only two developers on the entire project, my responsibilities included the design, all art, all game code, several maps, effects, web page art, and UI art. Most of my time on Coda was spent programming. Detailed histories of the tasks required are available in the Coda bug tracker. I am currently working on a series of Coda comics for our fans who have voiced an interest in Coda's plot. Coda is currently being ported to Epic's recently released UDK.

Coda's focus is on thoughtful, unforgiving, competitive, fast paced and stylish team-based gameplay. Coda has a sword combat system that interprets player mouse movements as attacks. Tightly integrated into the sword fighting gameplay are a maneuvering system based on the 2D fighter genre and unique magic system.


Some of Coda's notable accomplishments include:
MakeSomethingUnrealContest Phase 1 Winner
MakeSomethingUnrealContest Phase 2 Winner
MakeSomethingUnrealContest Phase 3 Winner
Auto Updater/Installer
First and only total conversion on the PlayStation3
Original magic system
Original item system
Interesting and competitive sword combat
Localized to 5 languages
9 maps at launch
4 original characters
Customizable character color palettes
Rideable Mule vehicle with mounted sword attacks
Highly polished network simulation
Coda's art was created in Maya using my DenreiMaya scripts. You can check out the game's documentation in the CodaWiki, but watching the tutorials we made for the Coda community is probably the best way to get the gist of what Coda is all about.
`
